import { useState, useMemo } from 'react';

import type { GetGooglePOIStylesDependingPOIFiltersParams } from 'src/utils/getGooglePOIStylesDependingPOIFilters';
import getGooglePOIStylesDependingPOIFilters from 'src/utils/getGooglePOIStylesDependingPOIFilters';

export type GooglePOIFiltersValues = GetGooglePOIStylesDependingPOIFiltersParams & {
    setHideAttraction: React.Dispatch<React.SetStateAction<boolean>>;
    setHideBusiness: React.Dispatch<React.SetStateAction<boolean>>;
    setHideGovernment: React.Dispatch<React.SetStateAction<boolean>>;
    setHideMedical: React.Dispatch<React.SetStateAction<boolean>>;
    setHidePark: React.Dispatch<React.SetStateAction<boolean>>;
    setHidePlaceOfWork: React.Dispatch<React.SetStateAction<boolean>>;
    setHideSchool: React.Dispatch<React.SetStateAction<boolean>>;
    setHideSport: React.Dispatch<React.SetStateAction<boolean>>;
    styles: google.maps.MapTypeStyle[];
};
const useGooglePOIFilters = (): GooglePOIFiltersValues => {
    const [hidePark, setHidePark] = useState(false);
    const [hideBusiness, setHideBusiness] = useState(false);
    const [hideAttraction, setHideAttraction] = useState(false);
    const [hideGovernment, setHideGovernment] = useState(false);
    const [hideMedical, setHideMedical] = useState(false);
    const [hidePlaceOfWork, setHidePlaceOfWork] = useState(false);
    const [hideSchool, setHideSchool] = useState(false);
    const [hideSport, setHideSport] = useState(false);

    const styles = useMemo(
        () =>
            getGooglePOIStylesDependingPOIFilters({
                hidePark,
                hideBusiness,
                hideAttraction,
                hideGovernment,
                hideMedical,
                hidePlaceOfWork,
                hideSchool,
                hideSport,
            }),
        [hideAttraction, hideBusiness, hideGovernment, hideMedical, hidePark, hidePlaceOfWork, hideSchool, hideSport],
    );

    return {
        hideAttraction,
        hideBusiness,
        hideGovernment,
        hideMedical,
        hidePark,
        hidePlaceOfWork,
        hideSchool,
        hideSport,
        setHideAttraction,
        setHideBusiness,
        setHideGovernment,
        setHideMedical,
        setHidePark,
        setHidePlaceOfWork,
        setHideSchool,
        setHideSport,
        styles,
    };
};

export default useGooglePOIFilters;
